import { useState, useEffect } from 'react';
import SignupItem from "./SignupItem";
import axios from 'axios';
import qs from 'qs';
import {URL} from '../helpers/Options';

function SignupList( props ) {
	const [isLoading, setIsLoading] = useState(true);
	const [theSignups, setLoadedMeetups] = useState([]);
	useEffect(() => {
	  setIsLoading(true);
	  var data = {
		action: 	'SAS_handleAJAX',
		function: 	'getSignups',
	  };
	  axios.post(URL, qs.stringify(data)).then(
		function (response) {
		  setIsLoading(false);
		  setLoadedMeetups(response.data);
		}
	  );
	}, []);
  
	if (isLoading) {
		return <div>Loading...</div>;
	  } else {
		return (
			<div>
				{theSignups.map((signup) => (
					<SignupItem 
						key={signup.id}
						id={signup.id}
						activity={signup.fields.Activity}
						deadline={signup.fields.Deadline}
						expired={signup.fields.Expired}
						filled={signup.fields.Filled}
						remaining={signup.fields.Remaining}
						required={signup.fields.Required}
						status={signup.fields.Status}
					/>
					))
				}
			</div>
		)
  }
	
}

export default SignupList;